import { AvailabilityCard } from "@/features/clinician/availability/components/availability-card";

function ClinicianAvailability() {
    return (
        <>
            <div className="px-4 py-8">
                <div className="container mx-auto">
                    <h1 className="mb-4 text-2xl font-semibold">
                        Your availability
                    </h1>
                    <AvailabilityCard />
                </div>
            </div>
        </>
    );
}

export default ClinicianAvailability;
